$(document).ready(function () {
  if (!$('.acf-map-new').length) {
    return;
  }

  function render_map($el) {
    var $markers = $el.find('.marker-new');
    var args = {
      zoom: 16,
      center: new google.maps.LatLng(0, 0),
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      scrollwheel: false,
      styles: [
        {"elementType": "geometry", "stylers": [{"color": "#f5f3f3"}]},
        {"elementType": "labels.icon", "stylers": [{"visibility": "off"}]},
        {"elementType": "labels.text.fill", "stylers": [{"color": "#1e4a59"}]},
        {"elementType": "labels.text.stroke", "stylers": [{"color": "#f5f7f8"}, {"weight": 2}]},
        {"featureType": "landscape.natural", "elementType": "geometry", "stylers": [{"color": "#ddeae3"}]},
        {"featureType": "poi.park", "elementType": "geometry", "stylers": [{"color": "#ddeae3"}]},
        {"featureType": "poi.park", "elementType": "labels.text.fill", "stylers": [{"color": "#1e4a59"}]},
        {"featureType": "poi", "elementType": "geometry", "stylers": [{"color": "#ddeae3"}]},
        {"featureType": "poi", "elementType": "labels.text.fill", "stylers": [{"color": "#1e4a59"}]},
        {"featureType": "road", "elementType": "geometry", "stylers": [{"color": "#ffffff"}]},
        {"featureType": "road", "elementType": "labels.text.fill", "stylers": [{"color": "#78909c"}]},
        {"featureType": "road.highway", "elementType": "geometry", "stylers": [{"color": "#ffffff"}]},
        {"featureType": "road.highway", "elementType": "labels.text.fill", "stylers": [{"color": "#1e4a59"}]},
        {"featureType": "road.arterial", "elementType": "labels.text.fill", "stylers": [{"color": "#1e4a59"}]},
        {"featureType": "transit.line", "elementType": "geometry", "stylers": [{"color": "#cfdadf"}]},
        {"featureType": "transit.station", "elementType": "geometry", "stylers": [{"color": "#ebf0f1"}]},
        {"featureType": "water", "elementType": "geometry", "stylers": [{"color": "#d4e1e5"}]},
        {"featureType": "water", "elementType": "labels.text.fill", "stylers": [{"color": "#1e4a59"}]}
      ]
    };

    var map = new google.maps.Map($el[0], args);

    map.markers = [];

    $markers.each(function () {
      add_marker($(this), map);
    });
    center_map(map);
  }


  var infowindow;

  function add_marker($marker, map) {
    var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));
    var marker = new google.maps.Marker({
      position: latlng,
      map: map,
      icon: $marker.data('marker-icon')
    });

    map.markers.push(marker);

    if ($.trim($marker.html())) {
      infowindow = new google.maps.InfoWindow();

      google.maps.event.addListener(marker, 'click', function () {
        infowindow.close();
        infowindow.setContent($marker.html());
        infowindow.open(map, marker);
      });
    }
  }

  function center_map(map) {
    // vars
    var bounds = new google.maps.LatLngBounds();
    $.each(map.markers, function (i, marker) {
      var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
      bounds.extend(latlng);
    });
    if (map.markers.length == 1) {
      map.setCenter(bounds.getCenter());
    } else {
      map.fitBounds(bounds);
    }
  }

  $('.acf-map-new').each(function () {
    render_map($(this));
  });
});
